<div class="modal-backdrop-wrapper" *ngIf="showModal">
  <div class="custom-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          {{ subscriptionData ? "Edit Subscription" : "Add Subscription" }}
        </h5>
        <button type="button" class="close text-white" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()">
        <div class="modal-body row g-3">
          <div class="col-md-6">
            <label>Plan Name</label>
            <input
              type="text"
              formControlName="planName"
              class="form-control"
              placeholder="Enter Plan Name"
            />
            <div
              *ngIf="
                subscriptionForm.get('planName')?.touched &&
                subscriptionForm.get('planName')?.invalid
              "
              class="text-danger"
            >
              Plan Name is required
            </div>
          </div>

          <div class="col-md-6">
            <label>Plan Type</label>
            <select formControlName="planType" class="form-control">
              <option [ngValue]="null">--Select Plan Type--</option>
              <option [ngValue]="1">Upto 4 Tons</option>
              <option [ngValue]="2">4.1 – 50 Tons</option>
              <option [ngValue]="3">Top Up</option>
            </select>

            <div
              *ngIf="
                subscriptionForm.get('planType')?.touched &&
                subscriptionForm.get('planType')?.invalid
              "
              class="text-danger"
            >
              Load Capacity is required
            </div>
          </div>

          <div class="col-md-6">
            <label>Price</label>
            <input
              type="number"
              min="0"
              formControlName="price"
              class="form-control"
              placeholder="Enter price"
            />
            <div
              *ngIf="
                subscriptionForm.get('price')?.touched &&
                subscriptionForm.get('price')?.invalid
              "
              class="text-danger"
            >
              Price is required and must be 0 or more
            </div>
          </div>


          <!-- Validity Days -->
          <div
            class="col-md-6"
            *ngIf="
              subscriptionForm.get('planType')?.value == 2 ||
              subscriptionForm.get('planType')?.value == 3
            "
          >
            <label>Validity Days</label>

            <!-- If Plan Type = 3 → show disabled with -1 -->
            <input
              *ngIf="subscriptionForm.get('planType')?.value == 3"
              type="number"
              class="form-control"
              formControlName="validityDays"
              [value]="-1"
              disabled
            />
            <small
              *ngIf="subscriptionForm.get('planType')?.value == 3"
              class="text-muted"
            >
              Current Plan
            </small>

            <!-- If Plan Type = 2 → show normal input -->
            <input
              *ngIf="subscriptionForm.get('planType')?.value == 2"
              type="number"
              min="0"
              formControlName="validityDays"
              class="form-control"
              placeholder="Enter Days"
            />

            <div
              *ngIf="
                subscriptionForm.get('planType')?.value == 2 &&
                subscriptionForm.get('validityDays')?.touched &&
                subscriptionForm.get('validityDays')?.invalid
              "
              class="text-danger"
            >
              Validity Days are required
            </div>
          </div>

          <!-- Khali Gadi Add Post -->
          <div
            class="col-md-6"
            *ngIf="subscriptionForm.get('planType')?.value == 1"
          >
            <label>Khali Gadi Add Post</label>
            <input
              type="number"
              min="0"
              formControlName="khaliGadiAddPostDays"
              class="form-control"
              placeholder="Enter Days"
            />
          </div>

          <div
            class="col-md-6"
            *ngIf="
              subscriptionForm.get('planType')?.value == 2 ||
              subscriptionForm.get('planType')?.value == 3
            "
          >
            <label>Khali Gadi Add Post</label>

            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="khaliGadiMode"
                (change)="setUnlimitedKhali()"
                [checked]="isUnlimitedKhali"
              />
              <label class="form-check-label">Unlimited</label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="khaliGadiMode"
                (change)="setCustomKhali()"
                [checked]="!isUnlimitedKhali"
              />
              <label class="form-check-label">Enter Days</label>
            </div>

            <input
              *ngIf="!isUnlimitedKhali"
              type="number"
              min="0"
              formControlName="khaliGadiAddPostDays"
              class="form-control mt-2"
              placeholder="Enter Days"
            />
          </div>

          <!-- Want Load Contact (only for planType 2 & 3) -->
          <div
            class="col-md-6"
            *ngIf="
              subscriptionForm.get('planType')?.value == 2 ||
              subscriptionForm.get('planType')?.value == 3
            "
          >
            <label>Want Load Contact</label>

            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="wantLoadMode"
                (change)="setUnlimitedLoad()"
                [checked]="isUnlimitedLoad"
              />
              <label class="form-check-label">Unlimited</label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="wantLoadMode"
                (change)="setCustomLoad()"
                [checked]="!isUnlimitedLoad"
              />
              <label class="form-check-label">Enter Count</label>
            </div>

            <input
              *ngIf="!isUnlimitedLoad"
              type="number"
              min="0"
              formControlName="wantLoadContact"
              class="form-control mt-2"
              placeholder="Enter Contact Count"
            />
          </div>

          <!-- Earning -->
          <div
            class="col-md-6"
            *ngIf="subscriptionForm.get('planType')?.value == 1"
          >
            <label>Earning</label>
            <input
              type="number"
              min="0"
              formControlName="earning"
              class="form-control"
              placeholder="Enter earnings"
            />
            <div
              *ngIf="
                subscriptionForm.get('earning')?.touched &&
                subscriptionForm.get('earning')?.invalid
              "
              class="text-danger"
            >
              Earning is required
            </div>
          </div>

          <!-- Online Notification Days -->
          <div
            class="col-md-6"
            *ngIf="subscriptionForm.get('planType')?.value == 1"
          >
            <label>Online Notification Days</label>
            <input
              type="number"
              min="0"
              formControlName="onlineNotificationDays"
              class="form-control"
              placeholder="Enter Days"
            />
            <div
              *ngIf="
                subscriptionForm.get('onlineNotificationDays')?.touched &&
                subscriptionForm.get('onlineNotificationDays')?.invalid
              "
              class="text-danger"
            >
              Online Notification Days are required
            </div>
          </div>

          <div class="col-md-6">
            <label>Tax (%)</label>
            <input
              type="number"
              min="0"
              formControlName="tax"
              class="form-control"
              placeholder="Enter GST %"
            />
            <div
              *ngIf="
                subscriptionForm.get('tax')?.touched &&
                subscriptionForm.get('tax')?.invalid
              "
              class="text-danger"
            >
              Tax is required
            </div>
          </div>

          <div class="col-md-6">
            <label>Commission (%)</label>
            <input
              type="number"
              min="0"
              formControlName="commission"
              class="form-control"
              placeholder="Enter Commission %"
            />
            <div
              *ngIf="
                subscriptionForm.get('commission')?.touched &&
                subscriptionForm.get('commission')?.invalid
              "
              class="text-danger"
            >
              Commission is required
            </div>
          </div>

          <div class="col-md-6">
            <label>Discount (%)</label>
            <input
              type="number"
              min="0"
              formControlName="discount"
              class="form-control"
              placeholder="Enter Discount %"
            />
            <div
              *ngIf="
                subscriptionForm.get('discount')?.touched &&
                subscriptionForm.get('discount')?.invalid
              "
              class="text-danger"
            >
              Discount is required
            </div>
          </div>
          <div class="col-md-6">
            <label>Plan Index</label>
            <input
              type="number"
              min="0"
              formControlName="planIndex"
              class="form-control"
              placeholder="Enter index"
            />
            <div
              *ngIf="
                subscriptionForm.get('planIndex')?.touched &&
                subscriptionForm.get('planIndex')?.invalid
              "
              class="text-danger"
            >
              Plan index is required
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()">
            Close
          </button>
          <button
            type="submit"
            class="btn btn-success"
            [disabled]="subscriptionForm.invalid"
          >
            {{ subscriptionData ? "Update" : "Add" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
